import { ChangeCandidateDto } from '../change-candidate-dto';
import { PackagingComponentDto } from 'src/app/data-transfer/entities/component-entities/packaging-component-dto';

export class ChangeComponentCandidateDto extends ChangeCandidateDto {
    updatedPackagingComponent!: PackagingComponentDto;
    existingPackagingComponent!: PackagingComponentDto;
}
